export default class DesactivarAnioCurso {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idAnioCurso) {
    try {
      const result = await this.#repository.desactivarAnioCurso(idAnioCurso)
      return result
    } catch (error) {
      throw error
    }
  }
}
